import { CommonModule } from '@angular/common';
import { TopicRoutingModule } from './topic-routing.module';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { ExercisesComponent } from './exercises/exercises.component';
import { FormsModule } from '@angular/forms';
import { TopicService } from './topic.service';
import { LanguageProvider } from './language.provider';
import { TopicComponent } from './topic/topic.component';
import { TExercisesComponent } from './t-exercises/t-exercises.component';
import { DndModule } from 'ng2-dnd';
import { TAllExercisesComponent } from './t-all-exercises/t-all-exercises.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ExamComponent } from './exam/exam.component';
import { EvaluationComponent } from './evaluation/evaluation.component';
import { SharedModule } from '../shared/shared.module';
import { OpenQuestionComponent } from './open-question/open-question.component';
import { TOpenQuestionComponent } from './t-open-question/t-open-question.component';
import { TExamComponent } from './t-exam/t-exam.component';
import { TAllExamsComponent } from './t-all-exams/t-all-exams.component';
import { MultipleChoiceComponent } from './multiple-choice/multiple-choice.component';
import { TMultipleChoiceComponent } from './t-multiple-choice/t-multiple-choice.component';
import { EncodeTextComponent } from './encode-text/encode-text.component';
import { CaesarComponent } from './caesar/caesar.component';
import { CryptoService } from './crypto.service';
import { TEncodeTextComponent } from './t-encode-text/t-encode-text.component';
import { DecodeTextComponent } from './decode-text/decode-text.component';
import { TDecodeTextComponent } from './t-decode-text/t-decode-text.component';
import { DecodeWithoutKeyComponent } from './decode-without-key/decode-without-key.component';
import { TDecodeWithoutKeyComponent } from './t-decode-without-key/t-decode-without-key.component';
import { InputFieldComponent } from './input-field/input-field.component';
import { DefineKeyComponent } from './define-key/define-key.component';
import { TDefineKeyComponent } from './t-define-key/t-define-key.component';
import { DiscoverComponent } from './discover/discover.component';
import { TDiscoverComponent } from './t-discover/t-discover.component';
import { PolybiusComponent } from './polybius/polybius.component';
import { SkytaleComponent } from './skytale/skytale.component';
import { MonoalphabeticComponent } from './monoalphabetic/monoalphabetic.component';
import { TrueKeyDirective } from './true-key.directive';
import { VignereComponent } from './vignere/vignere.component';
import { PigpenEditorComponent } from './pigpen-editor/pigpen-editor.component';
import { PigpenComponent } from './pigpen/pigpen.component';
import { AtbashComponent } from './atbash/atbash.component';
import { MorseComponent } from './morse/morse.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MorseEditorComponent } from './morse-editor/morse-editor.component';
import { LearnByHeartComponent } from './learn-by-heart/learn-by-heart.component';
import { TLearnByHeartComponent } from './t-learn-by-heart/t-learn-by-heart.component';
import { PlaygroundComponent } from './playground/playground.component';
import { ExampleComponent } from './example/example.component';
import { TExampleComponent } from './t-example/t-example.component';

@NgModule({
  imports: [
    CommonModule,
    TopicRoutingModule,
    FormsModule,
    DndModule,
    BrowserAnimationsModule,
    NgbModule,
    NgxChartsModule,
    SharedModule
  ],providers: [TopicService,
    LanguageProvider,
    { provide: APP_INITIALIZER, useFactory: languageProviderFactory, deps: [LanguageProvider], multi: true }, CryptoService],
  declarations: [
    ExercisesComponent,
    TopicComponent,
    TExercisesComponent, 
    TAllExercisesComponent, 
    ExamComponent, 
    EvaluationComponent, 
    OpenQuestionComponent, 
    TOpenQuestionComponent, 
    TExamComponent, 
    TAllExamsComponent, 
    MultipleChoiceComponent, 
    TMultipleChoiceComponent, EncodeTextComponent, CaesarComponent, TEncodeTextComponent, DecodeTextComponent, TDecodeTextComponent, DecodeWithoutKeyComponent, TDecodeWithoutKeyComponent, InputFieldComponent, DefineKeyComponent, TDefineKeyComponent, DiscoverComponent, TDiscoverComponent, PolybiusComponent, SkytaleComponent, MonoalphabeticComponent, TrueKeyDirective, VignereComponent, PigpenEditorComponent, PigpenComponent, AtbashComponent, MorseComponent, MorseEditorComponent, LearnByHeartComponent, TLearnByHeartComponent, PlaygroundComponent,   ExampleComponent, TExampleComponent]
})
export class CryptoModule { }

export function languageProviderFactory(provider: LanguageProvider) {
  return () => provider.load();
}
